import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import { Avatar, Box, Grid, IconButton, styled } from "@mui/material";
import { useEffect } from "react";
import WhatsAppIcon from "@icons-rf/property-panel/whatsapp.svg?react";
import MessageIcon from "@icons-rf/property-panel/message-icon.svg?react";
import { redirectEmail } from "@/src-refactor/modules/shared/helpers/email.helper";
import { formatPhoneNumberWithExtention } from "@/src-refactor/modules/shared/helpers/formar-phone-number-with-ext.helper";
import getInitialsLetter from "@/src-refactor/modules/shared/helpers/first-letter-word.helper";
import SimpleCard from "@/src-refactor/modules/shared/components/SimpleCard";
import { getTruncatedDescription } from "@/src-refactor/modules/shared/helpers/truncate-multiple";
import ENVIRONMENT_VAR from "@/src-refactor/modules/shared/model/const/env/env.const";
import MxTypography from "@rf-l1/MxTypography";
import MxDetailCardAgent, {
  MxDetailCardAgentProps
} from "@rf-l1/page/details/card-agents/MxDetailCardAgent";

export interface IAgenciesDetailResponse {
  agencyId: number;
  name: string;
  phone: number;
  email: string;
  picture: string;
  is_active: number;
  user_status: string;
  brokers: Broker[];
}

export interface Broker {
  broker: Broker[];
}

const BrokersCard = () => {
  const {
    PROPERTY_DETAIL: { agents, principalData }
  } = useRealEstateDetailContext();

  useEffect(() => {}, []);

  const openNumberWhatsApp_ = (e: any) => {
    const agent = e.getExtraDataCallback();

    const publicUrl = `${ENVIRONMENT_VAR.REMAX_DOMAIN}${
      principalData.is_collection ? "/collection" : ""
    }/propiedad/${principalData?.realstate_type
      .replaceAll(" ", "-")
      .replaceAll("/", "o")
      .toLowerCase()}/${principalData.id}`;

    const messageText = `${publicUrl}`;
    const link = `https://api.whatsapp.com/send?phone=1${encodeURIComponent(
      agent.mobile ?? agent.phone
    )}&text=${encodeURIComponent(messageText)}`;
    window.open(link, "_blank");
  };

  const openEmail_ = (e: any) => {
    const agent = e.getExtraDataCallback();
    redirectEmail(agent.email);
  };

  const agentsActive = agents.some((agent: any) => agent.user_status === "Active");
  const agentsDATA: MxDetailCardAgentProps["agents"] = agents.map(x => ({
    agencyName: x.agency_name,
    email: x.email,
    messageCallback: openEmail_,
    WhatsappCallback: openNumberWhatsApp_,
    name: x.name,
    picture: x.picture,
    phone: formatPhoneNumberWithExtention(x.mobile ?? x.phone),
    getExtraDataCallback(e) {
      return x;
    }
  }));

  return (
    <Box my={2}>
      <MxDetailCardAgent agents={agentsDATA} title="Agentes" />
    </Box>

    // <SimpleCard showBg={true} title="Agentes">
    //   {agents.map((agent: any) => (
    //     <Content
    //       style={{
    //         marginBottom: agents.length > 1 ? "15px" : 0,
    //         filter: agent.user_status === "Activo" ? "none" : "opacity(0.5)"
    //       }}
    //       key={agent.id}
    //     >
    //       <Grid>
    //         <CustomAvatar
    //           alt={agent.name}
    //           src={agent.picture ?? ""}
    //           sx={{ width: 70, height: 70 }}
    //           children={agent.name ? getInitialsLetter(agent.name) : undefined}
    //         ></CustomAvatar>
    //         {agent.user_status !== "Activo" && (
    //           <Grid>
    //             <MxTypography variant="overline" marginTop={0.9}>
    //               Suspendido
    //             </MxTypography>
    //           </Grid>
    //         )}
    //       </Grid>
    //       <ContentCardText>
    //         <MxTypography
    //           color="primary.main"
    //           variant="caption"
    //           fontWeight={600}
    //           align="left"
    //         >
    //           {agent.name}
    //         </MxTypography>
    //         {/* <TextSimple
    //           color="blue"
    //           font="gotham"
    //           size="sub-title"
    //           weight="bold"
    //           align="left"
    //           msgtooltip={}
    //           tooltipWithoutIcon
    //         >
    //           {agent.name}
    //         </TextSimple> */}

    //         <TextSimple
    //           color="gray"
    //           font="inter"
    //           size="sub-title"
    //           weight="300"
    //           truncate
    //           lineTruncate={1}
    //         >
    //           {agent.agency_name}
    //         </TextSimple>

    //         <TextSimple
    //           color="gray"
    //           font="gotham"
    //           size="sub-title"
    //           weight="400"
    //           truncate
    //           lineTruncate={1}
    //           msgtooltip={formatPhoneNumberWithExtention(
    //             agent.mobile ?? agent.phone
    //           )}
    //           tooltipWithoutIcon
    //         >
    //           {formatPhoneNumberWithExtention(agent.mobile ?? agent.phone)}
    //         </TextSimple>

    //         <TextSimple
    //           color="blue"
    //           font="inter"
    //           size="sub-title"
    //           weight="700"
    //           tooltipWithoutIcon
    //           msgtooltip={formatPhoneNumberWithExtention(agent.email)}
    //         >
    //           <span
    //             style={{
    //               width: "100%",
    //               display: "flex",
    //               flexWrap: "wrap",
    //               wordBreak: "break-all",
    //               textAlign: "left"
    //             }}
    //           >
    //             {agent.email}
    //           </span>
    //         </TextSimple>
    //       </ContentCardText>

    //       <ButtonsContainer>
    //         <Button onClick={() => openNumberWhatsApp(agent.mobile ?? agent.phone)}>
    //           <WhatsAppIcon />
    //         </Button>
    //         <Button onClick={() => redirectEmail(agent.email)}>
    //           <MessageIcon />
    //         </Button>
    //       </ButtonsContainer>
    //     </Content>
    //   ))}
    // </SimpleCard>
  );
};

export default BrokersCard;

const Content = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "70px 1fr 50px",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.2rem",
  "& *": {
    textAlign: "center",
    objectPosition: "top"
  }
}));

const ContentCardText = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateRows: "repeat(3, 1fr)",
  justifyItems: "left",
  alignContent: "center",
  width: "90%",
  margin: "0 auto"
}));

const ButtonsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column"
}));

const Button = styled(IconButton)(({ theme }) => ({
  "& svg": {
    color: theme.palette.primary.main,
    width: "20px",
    height: "20px"
  }
}));

const CustomAvatar = styled(Avatar)(({ theme }) => ({}));
